var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"concat-us flex flex-end"},[_c('div',{staticClass:"concat-us-wrapper"},[_c('span',{staticClass:"hmicon icon-fuwuzhongxin"}),_c('span',[_vm._v(_vm._s(_vm.text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }